import { Grid, ToggleButton, ToggleButtonGroup, ToggleButtonProps, Tooltip } from '@mui/material';
import { Icon } from '@thro-types/users';

import { Form, useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';

import StyledDropzone from 'app/components/Dropzone';
import { SaveButton } from 'app/components/SaveButton';
import { translations } from 'locales/i18n';

const TooltipToggleButton = (props: ToggleButtonProps) => {
  const { title, ...other } = props;
  return (
    <Tooltip title={title}>
      <ToggleButton {...other} />
    </Tooltip>
  );
};

export interface IconValues {
  type: 'default' | 'category';
  iconToUpload?: File;
  icon: Icon;
}

export const IconDrawerContent = () => {
  const { t } = useTranslation();
  const { values, setFieldValue, isSubmitting, isValid } = useFormikContext<IconValues>();
  return (
    <Form>
      <Grid container justifyContent={'center'} padding={2} alignItems={'flex-start'} gap={2}>
        <Grid container flex={1} overflow={'auto'} gap={2} paddingY={1}>
          <Grid container item justifyContent={'center'}>
            <ToggleButtonGroup
              exclusive
              value={values.type}
              onChange={(e, newType) => newType !== null && setFieldValue('type', newType)}
            >
              <TooltipToggleButton
                title={t(translations.pages.tileSettings.tooltips.defaultIcon())}
                value={'default'}
              >
                {t(translations.pages.tileSettings.defaultIcon())}
              </TooltipToggleButton>
              <TooltipToggleButton
                title={t(translations.pages.tileSettings.tooltips.categoryIcon())}
                value={'category'}
              >
                {t(translations.pages.tileSettings.categoryIcon())}
              </TooltipToggleButton>
            </ToggleButtonGroup>
          </Grid>
          <Grid item maxWidth={'100%'} alignSelf={'center'} justifyContent={'center'} flex={1}>
            <StyledDropzone
              name="iconToUpload"
              value={values.iconToUpload}
              setFieldValue={setFieldValue}
              placeholder={t(translations.pages.home.cardDrawer.placeholder.uploadImage())}
              className="product-create__dropzone"
              accept={{
                'image/jpeg': ['.jpeg', '.jpg'],
                'image/png': ['.png'],
                'image/svg+xml': ['.svg']
              }}
              single
              showPreview
            />
          </Grid>
        </Grid>
        <Grid container justifyContent={'flex-end'} marginTop={'auto'}>
          <SaveButton isSubmitting={isSubmitting} isValid={isValid} />
        </Grid>
      </Grid>
    </Form>
  );
};
